module.exports = __webpack_public_path__ + "static/media/people-fill.9847cf63.svg";